<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 min-h-[100vh]">
    <div class="h-full">
      <main class="h-full">
        <suspense>
          <slot name="left-content" />
        </suspense>
      </main>
    </div>
    <div class="bg-dark-slate-gray h-[100vh] min-h-full max-lg:hidden">
      <slot name="right-content" />
    </div>
  </div>
</template>
